import React, { createContext, useContext } from 'react';

export const MobileHelpContext = createContext(null);

export default function MobileHelpSlot({ active = true }) {
  const register = useContext(MobileHelpContext);
  return active ? <span ref={register} className="js-mobile-help-slot" /> : null;
}
